import React from 'react';
import { theme } from '@citygross/design-tokens';
import { BasePrimaryButton, Loading, LoadingContainer, LoadingSpinner, ButtonChildContainer, ButtonBadge } from './Button.styles.js';
var ButtonSize;

(function (ButtonSize) {
  ButtonSize[ButtonSize["small"] = 0] = "small";
  ButtonSize[ButtonSize["medium"] = 1] = "medium";
  ButtonSize[ButtonSize["large"] = 2] = "large";
  ButtonSize[ButtonSize["header"] = 3] = "header";
})(ButtonSize || (ButtonSize = {}));

var ButtonColor;

(function (ButtonColor) {
  ButtonColor[ButtonColor["primary"] = 0] = "primary";
  ButtonColor[ButtonColor["secondary"] = 1] = "secondary";
  ButtonColor[ButtonColor["white"] = 2] = "white";
  ButtonColor[ButtonColor["darkest"] = 3] = "darkest";
  ButtonColor[ButtonColor["lightest"] = 4] = "lightest";
  ButtonColor[ButtonColor["buttonGray"] = 5] = "buttonGray";
  ButtonColor[ButtonColor["brandPurple"] = 6] = "brandPurple";
  ButtonColor[ButtonColor["alertGreen"] = 7] = "alertGreen";
})(ButtonColor || (ButtonColor = {}));

function Button(_a) {
  var _b;

  var _c = _a.center,
      center = _c === void 0 ? true : _c,
      _d = _a.color,
      color = _d === void 0 ? 'primary' : _d,
      fullWidth = _a.fullWidth,
      flexReverse = _a.flexReverse,
      icon = _a.icon,
      selected = _a.selected,
      isDisabled = _a.isDisabled,
      loading = _a.loading,
      noWrap = _a.noWrap,
      _onClick = _a.onClick,
      _e = _a.size,
      size = _e === void 0 ? 'large' : _e,
      xsSize = _a.xsSize,
      borderRadius = _a.borderRadius,
      _f = _a.childGap,
      childGap = _f === void 0 ? 4 : _f,
      buttonBadge = _a.buttonBadge,
      noShadow = _a.noShadow,
      hoverBackground = _a.hoverBackground,
      badgeBackground = _a.badgeBackground,
      tabIndex = _a.tabIndex,
      children = _a.children;
  return React.createElement(BasePrimaryButton, {
    tabIndex: tabIndex,
    center: center,
    color: theme && theme.palette ? selected ? (_b = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _b === void 0 ? void 0 : _b.white : theme === null || theme === void 0 ? void 0 : theme.palette[color] : 'white',
    fullWidth: fullWidth,
    flexReverse: flexReverse,
    icon: icon,
    selected: selected,
    isDisabled: loading || isDisabled,
    loading: loading || null,
    noWrap: noWrap,
    size: size,
    xsSize: xsSize,
    onClick: function onClick(e) {
      return _onClick && _onClick(e);
    },
    borderRadius: borderRadius,
    childGap: childGap,
    hoverBackground: hoverBackground,
    noShadow: noShadow
  }, loading && React.createElement(Loading, null, React.createElement(LoadingContainer, {
    xsSize: xsSize,
    size: size
  }, React.createElement(LoadingSpinner, null))), icon ? React.createElement(ButtonChildContainer, {
    size: size,
    flexReverse: flexReverse,
    noWrap: noWrap,
    childGap: childGap
  }, icon, children) : children, React.createElement("span", {
    className: "ripple"
  }), buttonBadge ? React.createElement(ButtonBadge, {
    background: badgeBackground
  }, buttonBadge) : null);
}

export { Button, ButtonColor, ButtonSize };